export default __webpack_public_path__ + "static/media/thumb-up-green.1a7d796e.svg";